import { store } from 'app/state/store'
import { UseMutationOptions } from 'react-query'
import { cancelImportingJob } from '../api/importJobs'
import { removeImportingJob, setImportingJobsStatusRequest } from '../state/jobsImportingSlice'
import { RequestStatus } from 'features/common'

export const cancelImportingJobMutationDef: UseMutationOptions<void, unknown, string> = {
  mutationKey: ['jobs', 'imports', 'cancel'],
  mutationFn: (jobId: string) => cancelImportingJob({ jobId }),
  onSuccess: (_data, jobId) => {
    // compatibility with old store, canceling means complete removal of job from list
    store.dispatch(removeImportingJob(jobId))
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onError: (error: any) => {
    // 400 means that job already finished or failed
    if (error.status === 400) {
      // to maintain compatibility with redux, ensure that job list is reloaded
      // compatibility with redux store
      store.dispatch(setImportingJobsStatusRequest(RequestStatus.Idle))
    }
  }
}
